import theme from '@app/ui/theme'
import styled from 'styled-components'
import styledNative from 'styled-components/native'

export const ModalContainer = styled.div<{ visible: boolean }>`
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 99999999;
  display: ${({ visible }) => (visible ? 'block' : 'none')};
`

export const ModalContainerBackground = styled.div`
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
`

export const ModalContentContainer = styled.div`
  width: 100vw;
  height: 100vh;
  position: relative;
`

export const ModalContent = styled.div`
  text-align: center;
  border-radius: 12px;
  border-color: transparent;
  background-color: ${theme.colors.white};
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 400px;
  padding: 16px;
  -shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
`

export const ModalTitle = styledNative.Text`
  font-weight: 600;
  font-size: 23px;
`
export const ModalDescription = styledNative.Text`
  font-weight: 400;
  font-size: 16px;
`
